module.exports = __webpack_public_path__ + "img/home-run.966e5d31.svg";